import { FC } from "react";
import { Box, Button, Flex } from "@mantine/core";
import { useGo } from "@refinedev/core";
import cx from "clsx";

import styles from "@scss/header/header.module.scss";
import Logo from "@images/logo/cwiggo-logo-console.svg";
import { SocialLinks } from "../footer/social-links";

interface CwiggoHeaderProps {
  isNotHomePage?: boolean;
}

export const CwiggoHeader: FC<CwiggoHeaderProps> = ({ isNotHomePage = false }) => {
  const go = useGo();

  const handleLogoClick = () => {
    go({
      to: "/",
      type: "push",
    });
  };

  return (
    <Box className={cx(styles.headerWrapper, { [styles.notHomePage]: isNotHomePage })}>
      <Box className={styles.headerContainer}>
        <Flex justify="space-between" align="center" mb={0} className={styles.headerContentWrapper}>
          <SocialLinks />
          <img
            className={"headerLogo"}
            src={Logo}
            alt={"AC Brands Logo"}
            onClick={handleLogoClick}
            style={{ cursor: "pointer" }}
          />
          {/* <Button
            variant={"primary"}
            onClick={() => go({ to: "/contact-us", type: "push" })}
            tt="uppercase"
            fw={600}
            fz={14}
          >
            Contact Us
          </Button> */}
          <Button
            variant={"primary"}
            onClick={() => go({ to: "/faq", type: "push" })}
            tt="uppercase"
            fw={600}
            fz={14}
          >
            FAQs
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};
